import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: ${({ theme }) => `${theme.spacing(1)} ${theme.spacing(2)}`};
  height: 3.2rem;
`;

export const LabelWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.palette.text.secondary};

  font-size: 1.6rem;
  line-height: 62.5%;

  & > svg {
    width: 1em;
    height: 1em;
  }
`;

export const Label = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.body2)};
`;
